@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 22px;
}

.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: var(--chat-message-width);
}

.body {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  background: var(--background-default);
  @include border-radius-r2;
}

.bodyWithBorder {
  composes: body;
  border: 1px solid var(--border-soft);
}

.title {
  width: calc(var(--chat-message-width) - 1px);
  background-color: var(--surface-default);
  padding: 16px;
  border-top-left-radius: border-radius(r2);
  border-top-right-radius: border-radius(r2);
  @include typography-v2-title-base;
  white-space: pre-wrap;
  border: 1px solid var(--border-soft);
}

.titleRoundedBottom {
  composes: title;
  border-bottom-left-radius: border-radius(r2);
  border-bottom-right-radius: border-radius(r2);
  border: none;
}

.content {
  @include typography-v2-body-base;
}

.contentWithPadding {
  composes: content;
  padding: 16px;
}

.chatPromptsContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.loaderWrapper {
  padding: 12px 16px;
}

.loader {
  background: var(--background-default);
  margin: 0;
}
